import $ from 'jquery';
import React from 'react';
import { string } from 'prop-types';
import { createBrowserHistory } from 'history';
// import { getQueryParams } from 'utils/query-param-helpers';
// import { attachEnterAsClickDecorator } from 'utils/attachEnterAsClick';
import scrollTo from 'utils/scroll-to';
import Loader from '../loader';
import TabsSection from './tabs/';
import TabItemsSection from './items/';
import { tabContentItems, paginateItems } from './utils/item-filter';

export default class TabListing extends React.Component {
    constructor(props) {
        super(props);

        this.history = createBrowserHistory();
        this.state = {
            isLoading: true,
            data: {
                tabOptions: [],
                contentData: [],
                resources: [],
                settings: {}
            },
            APIStatus: '',
            APIMessage: '',
            currentSort: 'default',
            currentPage: 0, // page 1 is 0 (array index value)
            currentPageSize: 5,
            showMoreSize: 5,
            currentTab: 0
        };

        this.selectTab = this.selectTab.bind(this);
        this.showMore = this.showMore.bind(this);
    }

    componentDidMount() {
        const newState = { ...this.state };
        const pageData = this.props.data.trim();

        // check for JSON data on the page,
        // If it exists then we're getting data from local mock json file
        if (pageData && pageData.length) {
            // convert the page contents to JSON format & set to state
            const jsonPageData = $.parseJSON(pageData);
            this.setData(jsonPageData, newState);

            // hide the loader if we have items from mock JSON page data
            if (jsonPageData.contentData && jsonPageData.contentData.length > 0) {
                newState.isLoading = false;
            }

            // if no result
            if (this.state.data.contentData.length === 0) {
                newState.isLoading = false;
            }

            // update the app state with new preset filter values
            this.setState(newState);
        } else {
            // If the app is still loading then get data from API
            if (this.state.isLoading) {
                // fetch data from API endpoint
                this.fetchItems(this.props.url, newState);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.history.replace({ pathname: window.location.pathname });

        if (prevState.currentPage !== this.state.currentPage) {
            scrollTo(document.body, 0, 200);
        }
    }

    setData(data, newState) {
        // set results & settings
        newState.data.tabOptions = data.tabOptions;
        newState.data.contentData = data.contentData;
        newState.data.settings = data.settings;
    }

    fetchItems(url, newState) {
        $.getJSON(`/api/${url}`)
            .fail((jqxhr, textStatus, error) => {
                newState.APIStatus = 'error';
                newState.APIMessage = `${textStatus}, ${error}`;
                // update the app state with api error values
                this.setState(newState);
            })
            .done(response => {
                this.setData(response.data, newState);

                newState.isLoading = false;
                // update the app state with api data & new preset filter values
                this.setState(newState);
            });
    }

    selectTab(id) {
        this.setState({ currentTab: id });
    }

    showMore(event) {
        event.preventDefault();
        this.setState({ currentPageSize: this.state.currentPageSize + this.state.showMoreSize });
    }

    renderAPIErrorMessage() {
        if (this.state.APIStatus !== 'error') { return null; }

        return (
            <p className="validation-msg">Oops, something went wrong: {this.state.APIMessage}</p>
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div>
                    <Loader />
                    {this.renderAPIErrorMessage()}
                </div>
            );
        }

        const { tabOptions, contentData, settings } = this.state.data;
        const { tabsLayout } = this.props;
        
        // Provide default values for settings to prevent undefined prop errors
        const settingsWithDefaults = {
            showMoreButtonType: false,
            showMoreButtonLabel: 'Load More',
            itemsPerPage: 10,
            ...settings
        };
        
        const tabContent = tabContentItems(contentData, this.state.currentTab);
        const listingContent = this.state.currentTab > 0 ? tabContent : contentData;
        const pagedContent = paginateItems(listingContent, this.state.currentPage, this.state.currentPageSize);

        if (this.state.data.contentData.length === 0) {
            return (
                <div className={`no-result layout-${tabsLayout}`}>
                    <div className="container">
                        <p>No results found. Please try again with a different search term</p>
                    </div>
                </div>
            );
        }

        return (
            <div className={`layout-${tabsLayout}`}>
                <TabsSection
                    tabs={tabOptions}
                    selectTab={this.selectTab}
                    currentTab={this.state.currentTab}
                />
                <TabItemsSection
                    tabContent={pagedContent}
                    tabContentId={this.state.currentTab}
                    totalItems={tabContent.length}
                    showMoreButtonType={settingsWithDefaults.showMoreButtonType}
                    showMoreButtonLabel={settingsWithDefaults.showMoreButtonLabel}
                    showingItems={pagedContent.length < settingsWithDefaults.itemsPerPage
                        ? settingsWithDefaults.itemsPerPage
                        : pagedContent.length}
                    showMoreItems={this.showMore}
                />
            </div>
        );
    }
}

TabListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    url: string,
    data: string,
    // tileType: string,
    // tileContainerTilesWrap: string,
    tabsLayout: string
    /* eslint-enable react/no-typos */
};

TabListing.defaultProps = {
    url: '/',
    data: '',
    // tileType: 'base-tile',
    // tileContainerTilesWrap: 'tiles-wrap',
    tabsLayout: 'tabs'
};
